import { createAction } from '@reduxjs/toolkit';

export const furnitureInteractionComplete = 'dora/furnitureInteractionComplete';
export const floorSizeUpdated = 'dora/floorSizeUpdated';
export const loadLayoutWithDiscontinuedProduct = 'dora/loadLayoutWithDiscontinuedProduct';

export const furnitureInteractionCompleteAction = createAction<{
    productIds: string[];
    interactionType: 'move' | 'rotate';
}>(furnitureInteractionComplete);

export const floorSizeUpdatedAction = createAction<{
    originalDimensions: { x: number; y: number };
    newDimensions: { x: number; y: number };
}>(floorSizeUpdated);

export const loadLayoutWithDiscontinuedProductAction = createAction<{
    discontinuedProductIds: string[];
}>(loadLayoutWithDiscontinuedProduct);
